import { css } from '@emotion/react';
import { themeVariables } from './themeVariables';

const GlobalStyle = css`
  .toastr-component {
    .go2072408551 {
      background: #fff;
      font-size: ${themeVariables.fontSizes.smaller};
      font-weight: ${themeVariables.fontWeights.semibold};
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      padding: 0.5rem 1.5rem;

      .go685806154 {
        border-radius: 10px;
        padding: 0.5rem;
      }
    }

    .succes-toastr {
      .go685806154 {
        background: ${themeVariables.semanticColors.successBackground};
      }
    }

    .error-toastr {
      .go685806154 {
        background: ${themeVariables.semanticColors.errorBackground};
      }
    }
  }
`;

export default GlobalStyle;
